var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoCreditCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 429,
    viewBox: "0 0 508 429",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 146.426,
    y: 387.587,
    width: 159.83,
    height: 48.182,
    rx: 24.091,
    transform: "rotate(-30 146.426 387.587)",
    fill: "#E6E6E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -4.992,
    y: 308.036,
    width: 62.547,
    height: 48.128,
    rx: 24.064,
    transform: "rotate(-30 -4.992 308.036)",
    fill: "#E6E6E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 383.754,
    y: 28.025,
    width: 48.182,
    height: 48.182,
    rx: 24.091,
    transform: "rotate(-30 383.754 28.025)",
    fill: "#E6E6E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60.027,
    y: 214.93,
    width: 331.065,
    height: 48.182,
    rx: 24.091,
    transform: "rotate(-30 60.027 214.93)",
    fill: "#D0D0D0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 258.691,
    y: 322.77,
    width: 212.933,
    height: 48.182,
    rx: 24.091,
    transform: "rotate(-30 258.691 322.77)",
    fill: "#D0D0D0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 101.73,
    y: 302.128,
    width: 390.877,
    height: 48.182,
    rx: 24.091,
    transform: "rotate(-30 101.73 302.128)",
    fill: "#D0D0D0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 491.496,
    cy: 330.072,
    r: 12.5,
    stroke: "#E6E6E6",
    strokeWidth: 6.017
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 72.565,
    cy: 127.995,
    r: 9.291,
    stroke: "#E6E6E6",
    strokeWidth: 6.017
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 101.386,
    cy: 411.47,
    r: 14.249,
    stroke: "#E6E6E6",
    strokeWidth: 6.017
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 312.461,
    y: 0.301,
    width: 29.946,
    height: 5.348,
    rx: 2.674,
    fill: "#E6E6E6"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 410.695,
    y: 407.515,
    width: 22.46,
    height: 5.348,
    rx: 2.674,
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 424.602,
    y: 399.228,
    width: 22.46,
    height: 5.348,
    rx: 2.674,
    transform: "rotate(90 424.602 399.228)",
    fill: "#E6E6E6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.91,
    y: 251.789,
    width: 22.46,
    height: 5.348,
    rx: 2.674,
    fill: "#E6E6E6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 14.816,
    y: 243.501,
    width: 22.46,
    height: 5.348,
    rx: 2.674,
    transform: "rotate(90 14.816 243.501)",
    fill: "#E6E6E6"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 190.839,
    y: 83.903,
    width: 273.394,
    height: 164.589,
    rx: 24.723,
    transform: "rotate(20.324 190.839 83.903)",
    fill: "#ECECEC",
    stroke: "#AFAFAF",
    strokeWidth: 7.207
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 103.596,
    y: 180.446,
    width: 301.235,
    height: 181.635,
    rx: 24.723,
    fill: "#fff",
    stroke: "#AFAFAF",
    strokeWidth: 7.207
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.211 184.04h125.9c11.646 0 21.087 9.441 21.087 21.087v132.276c0 11.647-9.441 21.088-21.087 21.088h-125.9V184.04z",
    fill: "#ECECEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AFAFAF",
    d: "M99.992 288.744h308.442v37.768H99.992z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCreditCard);
export default __webpack_public_path__ + "static/media/no-credit-card.668a344f.svg";
export { ForwardRef as ReactComponent };